export const ECOM_VERSION = '1.48.0-beta1';
